import styled from '@emotion/styled'

export const MasterDetailView = styled.div`
  display: flex;
  justify-content: stretch;
  background: var(--White98);
`

export const Master = styled.div`
  width: 50%;
  min-width: 400px;
  padding: 36px 12px 36px 24px;
`
export const Detail = styled.div`
  width: 50%;
  min-width: 400px;
  padding: 36px 24px 36px 12px;
  position: sticky;
  height: calc(100vh - 100px);
  overflow-y: auto;
  top: 0px;
`
